import React from 'react';
import { Terminal } from 'lucide-react';
import { CollapsibleCard, CollapseControl } from './CollapsibleCard';

interface DebugLogProps {
  logs: string[];
  onClear: () => void;
  collapse?: CollapseControl;
}

export const DebugLog: React.FC<DebugLogProps> = ({ logs, onClear, collapse }) => {
  if (logs.length === 0) return null;

  return (
    <CollapsibleCard
      title="Dziennik diagnostyczny"
      icon={Terminal}
      titleClassName="text-accent-strong"
      iconClassName="text-accent-strong"
      open={collapse?.open}
      onOpenChange={collapse?.onOpenChange}
    >
      <div className="flex flex-col gap-2">
        <div className="flex justify-end">
          <button
            onClick={onClear}
            style={{
              padding: '4px 10px',
              // Token --error przez color-mix zamiast surowego rgba — działa też w dark (M-4)
              backgroundColor: 'color-mix(in srgb, var(--error) 8%, transparent)',
              color: 'var(--error)',
              border: '1px solid color-mix(in srgb, var(--error) 20%, transparent)',
              borderRadius: '8px',
              fontSize: '11px',
              cursor: 'pointer',
              fontWeight: '600',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = 'color-mix(in srgb, var(--error) 16%, transparent)')}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'color-mix(in srgb, var(--error) 8%, transparent)')}
          >
            Wyczyść
          </button>
        </div>
        <div style={{
          maxHeight: '200px',
          overflowY: 'auto',
          backgroundColor: 'var(--surface-subtle)',
          border: '1px solid var(--border)',
          borderRadius: '12px',
          padding: '12px',
          fontFamily: 'monospace',
          fontSize: '11px',
          lineHeight: '1.6',
          boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.02)'
        }}>
          {logs.map((log, index) => {
            const isError = log.includes('❌');
            const isSuccess = log.includes('✅');
            const isWarning = log.includes('⚠️');

            let textColor = 'var(--text-primary)'; // default
            let borderColor = 'var(--border-strong)';
            if (isError) {
              textColor = 'var(--error)';
              borderColor = 'var(--error)';
            } else if (isSuccess) {
              textColor = 'var(--success)';
              borderColor = 'var(--success)';
            } else if (isWarning) {
              textColor = 'var(--warning)';
              borderColor = 'var(--warning)';
            }

            return (
              <div
                key={index}
                style={{
                  color: textColor,
                  marginBottom: '4px',
                  paddingLeft: '8px',
                  borderLeft: `2.5px solid ${borderColor}`,
                  wordBreak: 'break-word'
                }}
              >
                {log}
              </div>
            );
          })}
        </div>
      </div>
    </CollapsibleCard>
  );
};
